import React from 'react';

import { useDebug } from '../debug/DebugProvider';

export function EnvDebug() {
  const { isDebugMode } = useDebug();
  if (!isDebugMode) return null;

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
  const lsUrl = typeof window !== 'undefined' ? localStorage.getItem('fw_supabase_url') : null;
  const lsKey = typeof window !== 'undefined' ? localStorage.getItem('fw_supabase_anon') : null;

  return (
    <div className="fixed top-0 right-0 bg-red-500 text-white p-4 text-xs z-50 max-w-md">
      <h3 className="font-bold mb-2">Environment Debug</h3>
      <div className="space-y-1">
        <div>
          <strong>SUPABASE_URL (env):</strong>
          <div className="break-all">{supabaseUrl}</div>
        </div>
        <div>
          <strong>Override URL (ls):</strong>
          <div className="break-all">{lsUrl || '—'}</div>
        </div>
        <div>
          <strong>Contains staging domain:</strong>
          {(lsUrl || supabaseUrl)?.includes('api.schulflex.app') ? '✅ YES' : '❌ NO'}
        </div>
        <div>
          <strong>KEY (env):</strong>
          {supabaseKey ? `${supabaseKey.substring(0, 20)}...` : 'MISSING'}
        </div>
        <div>
          <strong>Override KEY (ls):</strong>
          {lsKey ? `${lsKey.substring(0, 20)}...` : '—'}
        </div>
      </div>
    </div>
  );
}
